{
    "IncludeendedonholdLabel": "Includere la funzione On-Hold terminata:",
    "UnreturnedCalls_SectionHeader": "Chiamate non risposte",
    "UnreturnedCalls_SectionPara": "È possibile scegliere se le chiamate terminate in attesa sono considerate abbandonate nei rapporti \"Chiamate perse non restituite\" e nella statistica \"Chiamate non restituite\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Includere l'evasione:"
}